import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setTitle, toggleDrawer, ChangeFilter, intialiseState } from '../actions/AppActions';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { Switch, Route, Link, BrowserRouter as Router } from 'react-router-dom';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import { List, ListItem, ListItemIcon, ListItemText } from '../bundles/ListBundle';
import {
    MenuIcon,
    EinstellungenIcon,
    SyncIcon,
    AndroidIcon,
    ListIcon,
    LocalShippingIcon,
    DoneIcon,
} from '../bundles/IconsBundle';
import { VERSION } from '../settings';
import SwipeableDays from './SwipeableDays';
import BockListe from './BockListe';
import BockAbholung from './BockAbholung';
import Einshtellungen from './Einshtellungen';
import Sync from './Sync';
import Sicherungskopie from './Sicherungskopie';
// import SvgIcon from '@material-ui/core/SvgIcon';
import TaskView from './TaskView';
import AddPerson from './AddPerson';
import ManualCode from './ManualCode';
import ScanCode from './ScanCode';
import SignAuftrag from './SignAuftrag';
import SignAuftragMultiple from './SignAuftragMultiple';
import { SHOWN_TYPE_ERLEDIGTE, SHOWN_TYPE_OFFENE } from "../helpers/constants";
import LanguageSelector from '../extensions/LanguageSelector';
import { Text } from '../extensions/LangaugeContainer';
import DriverList from './DriverList';
//import DbTasks from '../db/DbTasks';
const classes = {
    appbar: {
        top: 0,
        height: 56,
        maxHeight: 56
    },
    child: {
        marginTop: 150,
    }
};

class MainLayout extends Component {
    constructor(props) {
        super(props);
        this.props.intialiseState();
    }    

    componentDidMount() {
        // this.interval = setInterval(() => {
        //   //console.log("Fahres GeoLocation update");
        //   const db = new DbTasks().updateFahrerGeolocation;
        //   db(this.props.settings);
        // },60*10000);
      }

      componentWillUnmount() {
        clearInterval(this.interval);
      }

    getAppBar = () => {
        return (
            <AppBar position='fixed' style={classes.appbar}>
                <Toolbar>
                    <IconButton color='inherit' aria-label='Menu' onClick={() => this.props.toggleDrawer(true)}>
                        <MenuIcon />
                    </IconButton>
                    <Typography variant='h6' color='inherit'>
                        {this.props.pageTitle}
                    </Typography>
                </Toolbar>
            </AppBar>
        );
    };

    doNothing = () => {
        window.location.reload();
    };


    showErledigte = () => {
        this.props.ChangeFilter(SHOWN_TYPE_ERLEDIGTE);
        this.props.setTitle(<Text tid="finished"/>);
    };
    showOffene = () => {
        this.props.ChangeFilter(SHOWN_TYPE_OFFENE);
        this.props.setTitle(<Text tid="delivery"/>); //Auslieferung
    };

    getTaskView = () => {
        // switch (this.props.application.company) {
        //     case COMPANY_BROEMSE:
        //         return <TaskView />;
        //     case COMPANY_GROWE:
        //         return <TaskViewGrowe />;
        //     case COMPANY_OST:
        //         return <TaskViewOst />;
        //     case COMPANY_MENCK:
        //         return <TaskViewMenck />;
        //     default:
        return <TaskView />;
    }

    getBockAbholungView = () => {
        return <BockAbholung />;
    }

    render() {
        //const companyImageName = 'bs';
        return (
            <Router>
                <div>
                    <SwipeableDrawer style={classes.child} open={this.props.application.drawerOpen} onClose={() => this.props.toggleDrawer(false)} onOpen={this.doNothing}>
                        <div tabIndex={0} role='button' onClick={() => this.props.toggleDrawer(false)} onKeyDown={() => this.props.toggleDrawer(false)}>
                            <AppBar style={classes.appbar} position='static'>
                                <Toolbar>
                                    <LocalShippingIcon  style={{fontSize:"36", color:"#FFF", marginRight:"10px"}}/>
                                    <Typography variant='h6' color='inherit'>
                                        {'  '}<Text tid="deliveryApp"/>
                                        <span style={{ fontSize: '0.6em' }}>
                                           &nbsp;{VERSION}
                                        </span>
                                    </Typography>
                                </Toolbar>
                            </AppBar>
                            <List>
                                <Link to='/' onClick={this.showOffene} style={{ textDecoration: 'none' }}>
                                    <ListItem button>
                                        <ListItemIcon>
                                            <LocalShippingIcon />
                                        </ListItemIcon>
                                        <ListItemText primary={<Text tid="delivery"/>} />
                                    </ListItem>
                                </Link>
                                <Link to='/' onClick={this.showErledigte} style={{ textDecoration: 'none' }}>
                                    <ListItem button>
                                        <ListItemIcon>
                                            <DoneIcon />
                                        </ListItemIcon>
                                        <ListItemText primary={<Text tid="finished"/>} />
                                    </ListItem>
                                </Link>
                                {/* <Link to='/bockabholung' onClick={this.showBockAbholung} style={{ textDecoration: 'none' }}>
                                    <ListItem button>
                                        <ListItemIcon>
                                            <SvgIcon>
                                                <path fill="#757575" d="M3,11H5V13H3V11M11,5H13V9H11V5M9,11H13V15H11V13H9V11M15,11H17V13H19V11H21V13H19V15H21V19H19V21H17V19H13V21H11V17H15V15H17V13H15V11M19,19V15H17V19H19M15,3H21V9H15V3M17,5V7H19V5H17M3,3H9V9H3V3M5,5V7H7V5H5M3,15H9V21H3V15M5,17V19H7V17H5Z" />
                                            </SvgIcon>
                                        </ListItemIcon>
                                        <ListItemText primary='Bock Abholung' />
                                    </ListItem>
                                </Link> */}
                                <Link to='/bockliste' onClick={this.showBockListe} style={{ textDecoration: 'none' }}>
                                    <ListItem button>
                                        <ListItemIcon>
                                            <ListIcon />
                                        </ListItemIcon>
                                        <ListItemText primary={<Text tid="bockList"/>} />
                                    </ListItem>
                                </Link>
                                <Link to='/einshtellungen' onClick={this.showEinstellungen} style={{ textDecoration: 'none' }}>
                                    <ListItem button>
                                        <ListItemIcon>
                                            <EinstellungenIcon />
                                        </ListItemIcon>
                                        <ListItemText primary={<Text tid="settings"/>} />
                                    </ListItem>
                                </Link>
                                <Link to='/sync' onClick={this.showSync} style={{ textDecoration: 'none' }}>
                                    <ListItem button>
                                        <ListItemIcon>
                                            <SyncIcon />
                                        </ListItemIcon>
                                        <ListItemText primary={<Text tid="sync"/>} />
                                    </ListItem>
                                </Link>
                                {this.props.settings.PrivilegedUserMenu && 
                                   <Link to='/driverList' onClick={this.showSync} style={{ textDecoration: 'none' }}>
                                   <ListItem button>
                                       <ListItemIcon>
                                           <SyncIcon />
                                       </ListItemIcon>
                                       <ListItemText primary={<Text tid="driverList"/>} />
                                   </ListItem>
                               </Link>}
                                <Link to='/sicherungskopie' onClick={this.showSicherungskopie} style={{ textDecoration: 'none' }}>
                                    <ListItem button>
                                        <ListItemIcon>
                                            <AndroidIcon />
                                        </ListItemIcon>
                                        <ListItemText primary={<Text tid="backup"/>} />
                                    </ListItem>
                                </Link>
                            </List>
                        </div>
                    </SwipeableDrawer>
                    <AppBar position='fixed' style={classes.appbar}>
                        <Toolbar>
                            <IconButton color='inherit' aria-label='Menu' onClick={() => this.props.toggleDrawer(true)}
                            >
                                <MenuIcon />
                            </IconButton>
                            <Typography variant='h6' color='inherit' style={{ flex: 1 }} align='left'
                            >
                                {this.props.pageTitle}
                               
                            </Typography>
                            <LanguageSelector />
                        </Toolbar>
                        
                    </AppBar>
                    <div style={{ marginTop: '56px' }}>
                        <Switch>
                            <Route exact path='/' render={() => <SwipeableDays />} />
                            <Route exact path='/bockabholung' render={() => <BockAbholung />} />
                            <Route exact path='/einshtellungen' render={() => <Einshtellungen />} />
                            <Route exact path='/sync' render={() => <Sync />} />
                            <Route exact path='/sicherungskopie' render={() => <Sicherungskopie />} />
                            <Route exact path='/bockliste' render={() => <BockListe />} />
                            <Route path="/task/:id/" render={this.getTaskView} />
                            {/* <Route path="/taskro/:id/" render={() => <TaskViewReadOnly />} /> */}
                            <Route path="/bockabholung/:id/" render={this.getBockAbholungView} />
                            <Route exact path="/addperson/:id/:person" render={() => {
                                return <AddPerson />;
                            }} />
                            <Route exact path="/manualcode/:id/" render={() => {
                                return <ManualCode />;
                            }} />
                            <Route exact path="/scancode/:id/" render={() => {
                                return <ScanCode />;
                            }} />
                            <Route exact path="/signauftrag/:id/" render={() => {
                                return <SignAuftrag />;
                            }} />
                            <Route exact path="/signauftragmultiple/:id/" render={() => {
                                return <SignAuftragMultiple />;
                            }} />
                            <Route exact path='/driverList' render={() => <DriverList />} />
                        </Switch>
                    </div>
                </div>
            </Router>
        );
    }

}

const mapStateToProps = state => ({
    application: state.app,
    pageTitle: state.app.pageTitle,
    settings: state.settings
});

export default connect(
    mapStateToProps,
    { setTitle, toggleDrawer, intialiseState, ChangeFilter }
)(MainLayout);